import { Stack, Typography } from '@mui/material';

export const LegendPromotionsConditions: React.FC = () => (
	<Stack mt={'6px'}>
		<Typography sx={{ fontSize: 'var(--font-size-micro)', fontStyle: 'italic' }}>
			{
				'* Te recordamos que seleccionando dpvale como forma de pago, no aplican ciertas promociones, por lo que puede variar el monto de tu carrito y lo que te presentamos en este PLAN DE PAGOS.'
			}
		</Typography>
	</Stack>
);
